module.exports = __webpack_public_path__ + "static/media/cake4.b1632bcc.jpg";